import HttpClient from "../HttpClient";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";
import Op from "../interfaces/SequalizeFilters/SequalizeTypes";
import moment from "moment";

export class SosAlertService {

  /**
   * Get all SOS Tickets
   * Filters supported:
   * - id
   * - referenceId
   */
  

  private processCreatedAtDateFilter(filters: any) {
  let createdAt;
  if (filters?.startDate) {
    createdAt = {
      [Op.gte.toString()]: moment(filters.startDate).startOf("day").toDate(),
    }
  }
  if (filters?.endDate) {
    if (createdAt) {
      createdAt = {
        ...createdAt,
        [Op.lte.toString()]: moment(filters.endDate).endOf("day").toDate(),
      }
    } else {
      createdAt = {
        [Op.lte.toString()]: moment(filters.endDate).endOf("day").toDate(),
      }
    }
  }
  return { createdAt };
}

  async getAllSosAlerts(
    limit: number,
    offset: number,
    filters: {
      id?: number;
      referenceId?: number;
      startDate?: string;
      endDate?: string;
      referenceModel?: string;
      status?: string;  
    },
    sort: any
  ) {
    const allowedFilters = {
      ...(filters?.id && { id: filters.id }),
      ...(filters?.referenceId && { referenceId: filters.referenceId }),
      ...(filters?.referenceModel && { referenceModel: filters.referenceModel }),
      ...(filters?.status && { status: filters.status }),
    };


    const sequelizeFilters = ConstructSequelizeFilters(
      allowedFilters,
      [],                 // no like/search fields
      ["id", "referenceId", "status"] // exact match only
    );

    const createdAtFilter = this.processCreatedAtDateFilter(filters);

    const response = await HttpClient.get(
      `/v1/common/support-ticket/sos-tickets`,
      {
        params: {
          limit,
          offset,
          filters: {
          ...sequelizeFilters,
          ...createdAtFilter,
        },
          sort,
        },
      }
    );

    return {
      data: response?.data?.data ?? [],
      total: response?.data?.count ?? 0,
    };
  }

  async getSosAlertById(ticketId: number) {
    const response = await HttpClient.get(
      `/v1/common/support-ticket/sos-tickets/${ticketId}`
    );
    return response?.data;
  }

  async addSosComment(
    sosId: number,
    payload: { commentOrFeedback: string }
  ) {
    const response = await HttpClient.patch(
      `/v1/common/support-ticket/sos-tickets/${sosId}`,
      payload
    );
    return response?.data;
  }

  async updateSosTicketStatus(ticketId: number, payload: any) {
    const response = await HttpClient.patch(
      `/v1/common/support-ticket/sos-tickets/${ticketId}/update-status`, payload
    )
    return response
  }
}
